import { render, staticRenderFns } from "./Rating_Disparity.vue?vue&type=template&id=c7b009dc&scoped=true"
import script from "./Rating_Disparity.vue?vue&type=script&lang=js"
export * from "./Rating_Disparity.vue?vue&type=script&lang=js"
import style0 from "./Rating_Disparity.vue?vue&type=style&index=0&id=c7b009dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7b009dc",
  null
  
)

export default component.exports